import React from 'react'

const ArticleV2ShapeBlockQuote = ({data}) => {
    return (
        <div>
            <h4>Shape Block Quote</h4>
            <h6>{data?.quote?.body}</h6>

            <style jsx>{`
                div {
                    margin-bottom: 2.5rem;
                }
                
                h4 {
                    text-align: center;
                }

                h6 {
                    font-size: 36px;
                    text-align: center;
                    padding: 24px;
                }
            `}</style>
        </div>
    )
}

export default ArticleV2ShapeBlockQuote


export const query = graphql`
	fragment V2ShapeBlockQuote on ContentfulV2ShapeBlockQuote {
        id
        quote: body {
            body
        }
	}
`